import { createUseStyles } from 'react-jss'

const useStyles: any = createUseStyles({
  wrapper: {
    paddingTop: '120px'
  },
})

export default useStyles
